var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.77778 9.4359C12.0449 9.4359 13.8946 11.1952 13.9957 13.4029L14 13.5932V15.3436C14 15.6759 13.7492 15.9505 13.4238 15.994L13.3333 16H2.66667C2.32916 16 2.05023 15.7531 2.00609 15.4327L2 15.3436V13.5932C2 11.3609 3.78679 9.53964 6.02895 9.44018L6.22222 9.4359H9.77778ZM9.77778 10.7487H6.22222C4.68175 10.7487 3.42289 11.9359 3.33791 13.4318L3.33333 13.5932V14.6872H12.6667V13.5932C12.6667 12.1306 11.5455 10.9258 10.1032 10.7666L9.94171 10.7532L9.77778 10.7487ZM8 0C10.3319 0 12.2222 1.86127 12.2222 4.15727C12.2222 6.45326 10.3319 8.31453 8 8.31453C5.66813 8.31453 3.77778 6.45326 3.77778 4.15727C3.77778 1.86127 5.66813 0 8 0ZM8 1.31282C6.40451 1.31282 5.11111 2.58632 5.11111 4.15727C5.11111 5.72821 6.40451 7.00171 8 7.00171C9.59549 7.00171 10.8889 5.72821 10.8889 4.15727C10.8889 2.58632 9.59549 1.31282 8 1.31282Z",
    fill: "#101513",
    fillOpacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIcon);
export default __webpack_public_path__ + "static/media/user-icon.f10dc40c8d38f2e888c3728c82da9f62.svg";
export { ForwardRef as ReactComponent };